// CONSTANTS are all caps.
const NS = 'SiteHeaderTopBarV2';
const CLS = 'siteHeaderTopBarV2';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/siteHeaderTopBar.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class SiteHeaderTopBarV2 {
	constructor($el) {
		// $el is the widget node return by the loadSiteHeaderTopBar function
		this.$el = $el;
		this.$html = $('html');

		this.$siteHeader = document.querySelector('.siteHeaderV2');
		this.$searchOpen = this.$el.querySelector(`${WG}searchOpen`);
	}

	init() {
		this.setSiteHeaderTopBar();
		this.$searchOpen.addEventListener('click', () => {
			$(this.$siteHeader).trigger('siteHeaderV2.siteHeaderSearchBarV2.open');
		});

		this.$html.css('font-size', `${this.getDefaultFontSize()}px`);
	}

	setSiteHeaderTopBar() {
		// Add Some logic here
		$('.btn-decrease-font').on('click', (e) => {
			this.adjustFontSize(-2);
		});

		$('.btn-increase-font').on('click', (e) => {
			this.adjustFontSize(2);
		});

		this.initLanguageSwitcher();
	}

	getDefaultFontSize() {
		let defaultFontSize = localStorage.getItem('bc.defaultFontSize');
		let initialDefaultFontSize = 16;

		if(defaultFontSize) {
			return +defaultFontSize;
		}
		localStorage.setItem('bc.defaultFontSize', initialDefaultFontSize);
		return initialDefaultFontSize;
	}

	adjustFontSize(increment) {
		let defaultFontSize = this.getDefaultFontSize();

		if (increment > 0) {
			defaultFontSize = (defaultFontSize >= 18)
						? 18
						: defaultFontSize + increment;
		} else {
			defaultFontSize = (defaultFontSize <= 14)
						? 14
						: defaultFontSize + increment;
		}
		localStorage.setItem('bc.defaultFontSize', defaultFontSize);
		this.$html.css('font-size', `${defaultFontSize}px`);
	}


	initLanguageSwitcher() {
		$(`${WG}lang-btn`).on('click', (e) => {
			$(`${WG}lang-icon`).toggleClass('icon-chevron-down icon-chevron-up');
			$(`${WG}lang-list`).toggleClass('d-none');
		});

		$(document).mouseup((e) => {
			let container = $('.siteHeaderTopBarV2-lang-btn'); // YOUR CONTAINER SELECTOR
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				// container.hide();
				$(`${WG}lang-icon`).addClass('icon-chevron-up');
				$(`${WG}lang-icon`).removeClass('icon-chevron-down');
				$(`${WG}lang-list`).addClass('d-none');
			}
		});
	}
	// Add more functions like on above here
}
